export enum ServiceStatus {
  AddServiceStatus = 'Add Service Status',
  EditServiceStatus = 'Update Service Status',
  ListServiceStatuses = 'List Service Statuses'
}